var _a;
import { FileType } from '@office-start/document-types';
import { HarmonyThemeType, } from '../model/harmonyThemeData';
import { OfficeThemeMode } from '../model/officeStartTheme';
/**
 * App themes for supported file types on app pages in Harmony.
 * Used to override color data on launch or start pages.
 */
export var HarmonyAppThemes = (_a = {},
    _a[FileType.Word] = {
        fileType: FileType.Word,
        headerResources: {
            edgeworthResourcesTitleKey: 'wordName',
            helpNamespace: 'WDWAENDUSER',
        },
        id: FileType.Word,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#0E336A',
            Dark: '#13458F',
            DarkAlt: '#1651AA',
            Primary: '#185ABD',
            Secondary: '#2E6AC5',
            Tertiary: '#6794D7',
            Light: '#AEC6EB',
            Lighter: '#D2E0F4',
            LighterAlt: '#D2E0F4',
            DarkTheme: {
                Darker: '#82ABF1',
                Dark: '#598FEC',
                DarkAlt: '#3D7CE8',
                Primary: '#296FE6',
                Secondary: '#2461CA',
                Tertiary: '#19428A',
                Light: '#0C2145',
                Lighter: '#071225',
                LighterAlt: '#071225',
            },
        },
    },
    _a[FileType.Excel] = {
        fileType: FileType.Excel,
        headerResources: {
            edgeworthResourcesTitleKey: 'excelName',
            helpNamespace: 'XLWAENDUSER',
        },
        id: FileType.Excel,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#094624',
            Dark: '#0C5F32',
            DarkAlt: '#0F703B',
            Primary: '#107C41',
            Secondary: '#218D51',
            Tertiary: '#55B17E',
            Light: '#A0D8B9',
            Lighter: '#CAEAD8',
            LighterAlt: '#CAEAD8',
            DarkTheme: {
                Darker: '#60BD82',
                Dark: '#37A660',
                DarkAlt: '#1F954A',
                Primary: '#10893C',
                Secondary: '#0F7937',
                Tertiary: '#0A5325',
                Light: '#052912',
                Lighter: '#03160A',
                LighterAlt: '#03160A',
            },
        },
    },
    _a[FileType.PowerPoint] = {
        fileType: FileType.PowerPoint,
        headerResources: {
            edgeworthResourcesTitleKey: 'powerPointName',
            helpNamespace: 'PPWAENDUSER',
        },
        id: FileType.PowerPoint,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#6E220F',
            Dark: '#952F15',
            DarkAlt: '#B13719',
            Primary: '#C43E1C',
            Secondary: '#CB5031',
            Tertiary: '#DC816A',
            Light: '#EDBCB0',
            Lighter: '#F6DBD4',
            LighterAlt: '#F6DBD4',
            DarkTheme: {
                Darker: '#E1966D',
                Dark: '#D67540',
                DarkAlt: '#CF6024',
                Primary: '#CA5010',
                Secondary: '#B1470E',
                Tertiary: '#79310A',
                Light: '#3C1805',
                Lighter: '#200D03',
                LighterAlt: '#200D03',
            },
        },
    },
    _a[FileType.Sway] = {
        fileType: FileType.Sway,
        headerResources: {
            edgeworthResourcesTitleKey: 'sway',
            helpNamespace: 'STORYIM',
        },
        id: FileType.Sway,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            palette: true,
            token: true,
        },
        colors: {
            Darker: '#014446',
            Dark: '#025C5F',
            DarkAlt: '#026D70',
            Primary: '#03787C',
            Secondary: '#49AEB1',
            Tertiary: '#98D6D8',
            Light: '#C5E9EA',
            Lighter: '#F0F9FA',
            LighterAlt: '#F0F9FA',
            DarkTheme: {
                Darker: '#5AC6CC',
                Dark: '#2CB2B9',
                DarkAlt: '#11A5AC',
                Primary: '#009CA4',
                Secondary: '#008890',
                Tertiary: '#005D62',
                Light: '#002F31',
                Lighter: '#00191A',
                LighterAlt: '#00191A',
            },
        },
    },
    _a[FileType.OneNote] = {
        fileType: FileType.OneNote,
        headerResources: {
            edgeworthResourcesTitleKey: 'oneNoteName',
            helpNamespace: 'ONWAENDUSER',
        },
        id: FileType.OneNote,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#430E60',
            Dark: '#5B1382',
            DarkAlt: '#6C179A',
            Primary: '#7719AA',
            Secondary: '#862EB5',
            Tertiary: '#A864CD',
            Light: '#D1ABE6',
            Lighter: '#E6D1F2',
            LighterAlt: '#E6D1F2',
            DarkTheme: {
                Darker: '#EADEFF',
                Dark: '#DCCDF6',
                DarkAlt: '#CEBBED',
                Primary: '#C0AAE4',
                Secondary: '#9D87C4',
                Tertiary: '#7B64A3',
                Light: '#584183',
                Lighter: '#443168',
                LighterAlt: '#443168',
            },
        },
    },
    _a[FileType.Forms] = {
        fileType: FileType.Forms,
        headerResources: {
            edgeworthResourcesTitleKey: 'formsName',
            helpNamespace: 'MICROSOFTFORMS',
        },
        id: FileType.Forms,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            palette: true,
            token: true,
        },
        colors: {
            Darker: '#014446',
            Dark: '#025C5F',
            DarkAlt: '#026D70',
            Primary: '#03787C',
            Secondary: '#49AEB1',
            Tertiary: '#98D6D8',
            Light: '#C5E9EA',
            Lighter: '#F0F9FA',
            LighterAlt: '#F0F9FA',
            DarkTheme: {
                Darker: '#5AC6CC',
                Dark: '#2CB2B9',
                DarkAlt: '#11A5AC',
                Primary: '#009CA4',
                Secondary: '#008890',
                Tertiary: '#005D62',
                Light: '#002F31',
                Lighter: '#00191A',
                LighterAlt: '#00191A',
            },
        },
    },
    _a[FileType.Visio] = {
        fileType: FileType.Visio,
        headerResources: {
            edgeworthResourcesTitleKey: 'visioName',
            helpNamespace: 'VIWAENDUSER',
        },
        id: FileType.Visio,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#0E336A',
            Dark: '#13458F',
            DarkAlt: '#1651AA',
            Primary: '#185ABD',
            Secondary: '#2E6AC5',
            Tertiary: '#6794D7',
            Light: '#AEC6EB',
            Lighter: '#D2E0F4',
            LighterAlt: '#D2E0F4',
            DarkTheme: {
                Darker: '#82ABF1',
                Dark: '#598FEC',
                DarkAlt: '#3D7CE8',
                Primary: '#296FE6',
                Secondary: '#2461CA',
                Tertiary: '#19428A',
                Light: '#0C2145',
                Lighter: '#071225',
                LighterAlt: '#071225',
            },
        },
    },
    _a[FileType.Stream] = {
        fileType: FileType.Stream,
        headerResources: {
            edgeworthResourcesTitleKey: 'streamName',
            helpNamespace: 'STREAM',
        },
        id: FileType.Stream,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#6A0E28',
            Dark: '#8F1336',
            DarkAlt: '#AA1640',
            Primary: '#BC1948',
            Secondary: '#C52E59',
            Tertiary: '#D76787',
            Light: '#EBAEBF',
            Lighter: '#F4D2DC',
            LighterAlt: '#F4D2DC',
            DarkTheme: {
                Darker: '#F293B3',
                Dark: '#EE6F99',
                DarkAlt: '#EA5788',
                Primary: '#E8467C',
                Secondary: '#CC3D6D',
                Tertiary: '#8B2A4A',
                Light: '#461525',
                Lighter: '#250B14',
                LighterAlt: '#250B14',
            },
        },
    },
    _a[FileType.Clipchamp] = {
        fileType: FileType.Clipchamp,
        headerResources: {
            edgeworthResourcesTitleKey: 'clipchampName',
            helpNamespace: 'CLIPCHAMP',
        },
        id: FileType.Clipchamp,
        mode: OfficeThemeMode.default,
        type: HarmonyThemeType.App,
        colorOverrides: {
            token: true,
        },
        colors: {
            Darker: '#1E155A',
            Dark: '#31278E',
            DarkAlt: '#493CBD',
            Primary: '#6453E4',
            Secondary: '#978BFF',
            Tertiary: '#B1A8FF',
            Light: '#D4CCFF',
            Lighter: '#E3DEFF',
            LighterAlt: '#F3F0FF',
            DarkTheme: {
                Darker: '#7C6EFF',
                Dark: '#6453E4',
                DarkAlt: '#5446D0',
                Primary: '#F3F0FF',
                Secondary: '#3D31A5',
                Tertiary: '#31278E',
                Light: '#271C73',
                Lighter: '#1E155A',
                LighterAlt: '#130D3E',
            },
        },
    },
    _a);
//# sourceMappingURL=app.js.map